import { Helmet } from 'react-helmet-async';
import React from 'react';
import PropTypes from 'prop-types';

const MetaTags = ({ metadata }) => {
  if (!metadata || !metadata.length) {
    return null;
  }

  const metaTags = metadata
    .filter(item => item.name && item.content)
    .map(item => {
      const { name, content, isOgMetaTag } = item;

      if (isOgMetaTag) {
        return <meta property={name} content={content} key={name} />;
      }
      return <meta name={name} content={content} key={name} />;
    });
  return <Helmet>{metaTags}</Helmet>;
};

MetaTags.propTypes = {
  metadata: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      content: PropTypes.string.isRequired,
      isOgMetaTag: PropTypes.bool,
    }),
  ),
};

export default MetaTags;
